import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import { getConsent, loadPixel, setConsent, trackPageView } from "@/lib/metaPixel";

export const openCookieSettings = () => window.dispatchEvent(new Event("bgx-cookie-settings"));

function Toggle({ on, onChange, disabled, testid }) {
  return (
    <button type="button" role="switch" aria-checked={on} disabled={disabled} onClick={() => onChange(!on)} data-testid={testid}
      className={`relative w-11 h-6 rounded-full transition-colors ${on ? "bg-[#D6FF38]" : "bg-[#1F2937]"} ${disabled ? "opacity-60" : ""}`}>
      <span className={`absolute top-0.5 left-0.5 w-5 h-5 rounded-full bg-[#050608] transition-transform ${on ? "translate-x-5" : ""}`} />
    </button>
  );
}

export default function CookieConsent() {
  const { pathname, search } = useLocation();
  const [open, setOpen] = useState(() => !getConsent());
  const [manage, setManage] = useState(false);
  const [marketing, setMarketing] = useState(() => !!getConsent()?.marketing);

  useEffect(() => { loadPixel(); }, []);
  useEffect(() => { const t = setTimeout(trackPageView, 0); return () => clearTimeout(t); }, [pathname, search]);
  useEffect(() => {
    const h = () => { setMarketing(!!getConsent()?.marketing); setManage(true); setOpen(true); };
    window.addEventListener("bgx-cookie-settings", h);
    return () => window.removeEventListener("bgx-cookie-settings", h);
  }, []);
  if (!open) return null;
  const save = (m) => { setConsent(m); setMarketing(m); setOpen(false); setManage(false); };
  const btn = "mono text-[11px] uppercase tracking-widest px-3 sm:px-4 py-2.5 rounded-full transition-colors whitespace-nowrap";
  return (
    <div data-testid="cookie-banner" role="dialog" aria-label="Cookie preferences"
      className="fixed z-[100] bottom-2 left-2 right-2 sm:left-auto sm:right-5 sm:bottom-5 sm:max-w-md rounded-2xl border border-[#D6FF38]/40 bg-[#050608]/95 backdrop-blur-md text-[#E2E8F0] shadow-[0_0_40px_rgba(214,255,56,0.12)] p-4 sm:p-5">
      <div className="mono text-[10px] uppercase tracking-[0.25em] text-[#D6FF38]">Cookies</div>
      <p className="text-xs sm:text-sm mt-2 text-[#CBD5E1] leading-relaxed">
        <span className="hidden sm:inline">We use essential cookies to run the site. With your OK we'd also use a marketing cookie (Meta Pixel) to measure our adverts.
        It never receives your email, password or trading account details.</span>
        <span className="sm:hidden">Essential cookies run the site. With your OK we'd also use a marketing cookie (Meta Pixel) to measure adverts.</span>{" "}
        <Link to="/legal#cookies" className="text-[#38BDF8] underline" data-testid="cookie-policy-link">Cookie policy</Link>
      </p>
      {manage && (
        <div className="mt-4 space-y-3" data-testid="cookie-manage-panel">
          <div className="flex items-center justify-between gap-3">
            <div><div className="text-sm font-semibold">Essential</div><div className="text-xs text-[#94A3B8]">Login, checkout, security. Always on.</div></div>
            <Toggle on disabled onChange={() => {}} testid="cookie-toggle-essential" />
          </div>
          <div className="flex items-center justify-between gap-3">
            <div><div className="text-sm font-semibold">Marketing</div><div className="text-xs text-[#94A3B8]">Meta Pixel - ad measurement. Off unless you switch it on.</div></div>
            <Toggle on={marketing} onChange={setMarketing} testid="cookie-toggle-marketing" />
          </div>
        </div>
      )}
      <div className="flex flex-wrap gap-2 mt-3 sm:mt-4">
        {manage ? (
          <button onClick={() => save(marketing)} data-testid="cookie-save" className={`${btn} bg-[#D6FF38] text-[#050608] hover:bg-[#E6FF7A]`}>Save choices</button>
        ) : (
          <>
            <button onClick={() => save(true)} data-testid="cookie-accept-all" className={`${btn} bg-[#D6FF38] text-[#050608] hover:bg-[#E6FF7A]`}>Accept all</button>
            <button onClick={() => save(false)} data-testid="cookie-reject-all" className={`${btn} border border-[#D6FF38]/50 text-[#D6FF38] hover:bg-[#D6FF38]/10`}>Reject all</button>
            <button onClick={() => setManage(true)} data-testid="cookie-manage" className={`${btn} text-[#94A3B8] hover:text-white`}>Manage</button>
          </>
        )}
      </div>
    </div>
  );
}
